import { Divider } from '@tvg/fuse/divider';
import { GridItem, GridRow } from '@tvg/fuse/grid';
import React from 'react';
import styles from './BottomRow.module.css';
import ProductsPerPage from './ProductsPerPage/ProductsPerPage';
import ResultCount from './ResultCount';

function BottomRowComponent() {
  return (
    <GridRow className={styles.bottomRow}>
      <GridItem xxs={12} l={12}>
        <GridRow>
          <GridItem xxs={12} l={12}>
            <div className={styles.bottomRow__resultWrapper}>
              <ResultCount position="bottom" />
              <ProductsPerPage position="bottom" />
            </div>
          </GridItem>
        </GridRow>
      </GridItem>

      <GridItem xxs={12} className={styles.bottomRow__dividerContainer}>
        <Divider className={styles.bottomRow__divider} />
      </GridItem>
    </GridRow>
  );
}

export const BottomRow = React.memo(BottomRowComponent);
